import { useStore } from '@tanstack/react-store'
import * as appConfig from '@/lib/appConfig'

export const useAppConfig = (useStoreFn: typeof useStore = useStore) => ({
	appVersion: useStoreFn(appConfig.appVersion),
	apiUrl: useStoreFn(appConfig.apiUrl),
	signalRHubUrl: useStoreFn(appConfig.signalRHubUrl),
	oidc: useStoreFn(appConfig.oidcConfig),
})

export type AppConfig = ReturnType<typeof useAppConfig>

export * as appConfig from '@/lib/appConfig'
